import React, { forwardRef } from "react";
// @mui
import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

interface SvgColorProps {
  src?: string;
  width?: number;
  height?: number;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

const SvgColor = forwardRef<HTMLSpanElement, SvgColorProps>(
  ({ src, sx, width = 24, height = 24, ...other }, ref) => (
    <Box
      component="span"
      className="svg-color"
      ref={ref}
      sx={{
        width,
        height,
        display: "inline-block",
        bgcolor: "currentColor",
        mask: `url(${src}) no-repeat center / contain`,
        WebkitMask: `url(${src}) no-repeat center / contain`,
        ...sx,
      }}
      {...other}
    />
  ),
);

SvgColor.displayName = "SvgColor";

export default SvgColor;
